import { selectUserRolePermissions } from '@socialive/common';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import ReactTooltip from 'react-tooltip';

export default function DeleteRecordingButton({ onDelete, streamId }) {
  const { canDeleteVideo } = useSelector(selectUserRolePermissions);

  const tooltip = canDeleteVideo ? 'Delete' : 'No permission to delete';

  return (
    <>
      <li className="broadcast-option delete" data-for={`delete-recording-${streamId}-tooltip`} data-tip={tooltip}>
        <button
          type="button"
          className="bin-icon"
          disabled={!canDeleteVideo}
          onClick={onDelete}
          aria-label="Delete video"
        />
      </li>
      <ReactTooltip id={`delete-recording-${streamId}-tooltip`} effect="solid" type="light" border />
    </>
  );
}

DeleteRecordingButton.propTypes = {
  streamId: PropTypes.number.isRequired,
  onDelete: PropTypes.func.isRequired,
};
